module.exports = "<div id=\"viewPane\">\r\n</div>\r\n";